var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"},[_c('router-view',{key:_vm.$route.path})],1),_c('vue-progress-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }